import PageHeader from '@/components/feature/PageHeader';
import { Link } from 'react-router-dom';
import { characters } from '@/mocks/characters';
import { usePageMeta } from '@/hooks/usePageMeta';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '泡在我家的辣妹角色设定',
  description: '泡在我家的辣妹主要角色介绍与人物关系设定。',
  inLanguage: 'zh-CN',
  isPartOf: { '@type': 'WebSite', name: '泡在我家的辣妹资料站' },
  mainEntity: characters.map((c) => ({
    '@type': 'Person',
    name: c.name,
    description: c.tagline,
  })),
};

const accentClass: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function Characters() {
  usePageMeta({
    title: '泡在我家的辣妹角色设定 - 主要人物介绍与人物关系',
    description:
      '泡在我家的辣妹主要角色有哪些？这里介绍黑田美咲、佐藤悠斗等主要人物设定、性格特点与人物关系，帮你更快进入剧情。',
    keywords:
      '泡在我家的辣妹角色,泡在我家的辣妹人物,泡在我家的辣妹设定,泡在我家的辣妹人物关系,泡在我家的辣妹角色介绍',
    canonicalPath: '/characters',
    jsonLd,
  });

  return (
    <>
      <PageHeader
        eyebrow="角色设定"
        icon="ri-user-heart-line"
        title="泡在我家的辣妹主要角色"
        description="张扬的辣妹、内向的漫画宅、起哄的闺蜜……每一段关系都在推动剧情。这里整理了几位核心角色的性格特点与人物关系，帮你更快进入故事。"
        breadcrumbs={[{ label: '首页', to: '/' }, { label: '角色设定' }]}
      />

      <section className="bg-background-50 py-14 md:py-16">
        <div className="container-site">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {characters.map((c) => (
              <article
                key={c.id}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={c.image}
                    alt={`${c.name}（${c.role}）角色设定插画`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-start justify-between">
                    <div>
                      <h2 className="font-heading text-xl text-foreground-950">{c.name}</h2>
                      <p className="mt-1 text-xs text-foreground-500">{c.kana}</p>
                    </div>
                    <span className={`rounded-full px-3 py-1 text-xs font-medium ${accentClass[c.accent]}`}>
                      {c.role}
                    </span>
                  </div>
                  <p className="mt-3 text-sm font-semibold text-primary-700">{c.tagline}</p>
                  <p className="mt-2 text-sm leading-7 text-foreground-700">{c.desc}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {c.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-12 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <h2 className="font-heading text-lg md:text-xl">人物关系速览</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
              黑田美咲与佐藤悠斗是故事的核心，两人因"寄居"结缘，在相处中感情逐渐升温；
              闺蜜藤井千夏是最早的"神助攻"，妹妹佐藤美琴则以冷静的视角暗中推动；
              死党高桥和真承包笑点，也是两人关系的见证者。整体人物关系围绕"同一屋檐下"的日常展开，轻松又温馨。
            </p>
            <Link
              to="/plot"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              回到剧情介绍
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}